import { types as t, Instance } from 'mobx-state-tree';
import { ReportTypes } from '../types';

const BaseConfiguration = t.model('BaseConfiguration', {
  type: t.optional(t.enumeration('Type', Object.values(ReportTypes)), ReportTypes.air_quality),
  time_zone: t.maybeNull(t.string),
  working_hours: t.maybeNull(t.frozen()),
  working_days: t.maybeNull(t.frozen()),
  aggregate: t.maybeNull(t.number),
  include_logo: t.maybeNull(t.boolean),
  include_summary: t.maybeNull(t.boolean),
  // CSV / XLSX data table rows ('all' or 'metric_period'). Not editable: the app saves 'all', API clients
  // such as Noesis may ask for 'metric_period'. Kept in the model so it survives create / update / clone.
  data_table_rows: t.maybeNull(t.string)
});

export const OnceConfiguration = t.compose(
  t.model({
    date_from: t.maybeNull(t.string),
    date_to: t.maybeNull(t.string)
  }),
  BaseConfiguration
);

// Configuration for run_type: 'scheduled'
export const ScheduledConfiguration = t.compose(
  t.model({
    frequency: t.maybeNull(t.frozen()),
    start_of_the_week: t.maybeNull(t.frozen())
  }),
  BaseConfiguration
);

export interface IBaseConfiguration extends Instance<typeof BaseConfiguration> {}
export interface IOnceConfiguration extends Instance<typeof OnceConfiguration> {}
export interface IScheduledConfiguration extends Instance<typeof ScheduledConfiguration> {}

export default BaseConfiguration;
